<template>
  <div class="page">
    <div class="page-content" :class="size">
      <div v-if="!loading">
        <div class="level is-marginless">
          <div class="level-left">
            <button v-if="showBackTo" @click="goBack" class="button is-light">
              <b-icon icon="chevron-left"></b-icon>
              <span>{{ $t("back") }}</span>
            </button>
          </div>

          <div class="level-right">
            <slot name="page-header-upper-right"></slot>
          </div>
        </div>

        <div class="page-header" v-if="title">
          <div class="page-header-left">
            <div class="title is-3">{{ title }}</div>
          </div>

          <div class="page-header-right">
            <slot name="page-header-right"></slot>
          </div>
        </div>

        <slot></slot>
      </div>

      <div v-if="loading" class="has-text-centered" style="position: relative;">
        <img src="/images/loading.gif" style="width: 64px; height: 64px;" />
        <p>Уншиж байна ...</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String
    },

    backTo: {
      type: String,
      default: null
    },

    loading: {
      type: Boolean,
      default: false
    },

    size: {
      type: String,
      default: "is-full"
    }
  },

  computed: {
    showBackTo() {
      return this.backTo;
    }
  },

  methods: {
    goBack() {
      this.$router.push(this.backTo);
    }
  }
};
</script>
